<template>
	<toolbar>
		<h2><i class="fa fa-tags"></i> {{title}}</h2>

		<div class="controls">
			<slot></slot>

			<nav-tabs :tabs="tabs"
				addon-apps-location="Materials Module"
				addon-apps-link="/materials/apps">
			</nav-tabs>
		</div>

	</toolbar>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import NavTabs from "@/layout_fragments/NavTabs"

export default {
	components: {
		Toolbar,
		NavTabs
	},
	props: ["title"],
	data() {
		return {
			tabs: [
				{
					label: "Materials",
					path: "/materials/list",
					icon: "fa-list"
				},
				{
					label: "Labour Tasks",
					path: "/labour-tasks/list",
					icon: "fa-list"
				},
				{
					label: "Assemblies",
					path: "/materials/assemblies",
					icon: "fa-cubes"
				},
				{
					label: "Settings",
					path: "/materials/settings",
					icon: "fa-cog"
				}
			]
		}
	}
}
</script>